module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.f6d8f1ea.jpeg";